module.exports = __webpack_public_path__ + "img/Asistencia Vial.f49134f7.svg";